module.exports = __webpack_public_path__ + "static/media/performance-2.e6b23c35.jpg";